import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {postRequest, ResponseError} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {ICreditApplication} from "../types/ICreditApplication";

const applicationLink = apiPath.credit.application.create;

export const postCalculatorApplications = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postCreditApplication: build.mutation<unknown, ICreditApplication>({
            queryFn: async (params) => {
                try {
                    const postRes = await postRequest({}, applicationLink, params as unknown as unknown[]);
                    return {
                        data: postRes as unknown
                    };
                } catch (e) {
                    const resError = e as ResponseError;
                    const error: FetchBaseQueryError = {
                        status: resError.response.status,
                        data: resError.message
                    };
                    return {
                        error: error
                    };
                }
            }
        })
    })
});

export const {usePostCreditApplicationMutation} = postCalculatorApplications;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {postRequest, ResponseError} from "@pg-mono/request";
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {ICreditApplication} from "../types/ICreditApplication";

const applicationLink = apiPath.credit.application.create;

export const postCalculatorApplications = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postCreditApplication: build.mutation<unknown, ICreditApplication>({
            queryFn: async (params) => {
                try {
                    const postRes = await postRequest({}, applicationLink, params as unknown as unknown[]);
                    return {
                        data: postRes as unknown
                    };
                } catch (e) {
                    const resError = e as ResponseError;
                    const error: FetchBaseQueryError = {
                        status: resError.response.status,
                        data: resError.message
                    };
                    return {
                        error: error
                    };
                }
            }
        })
    })
});

export const {usePostCreditApplicationMutation} = postCalculatorApplications;
